import { Column, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn } from 'typeorm';

@Entity('transfer_action')
export class TransferAction {

    @PrimaryGeneratedColumn('increment', { name: 'transfer_action_id' })
    transferActionId: number;

    @Column({
        nullable: false,
        name: 'transfer_date',
        type: 'datetime',
        default: () => 'CURRENT_TIMESTAMP'
    })
    transferDate: Date;

    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'employee_code'
    })
    employeeCode: string;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'employee_name'
    })
    employeeName: string;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'designation'
    })
    designation: string;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'employee_role'
    })
    employeeRole: string;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'apporved_by'
    })
    approvedBy: string;

    @Column('varchar', {
        nullable: true,
        length: 50,
        name: 'from_plant'
    })
    fromPlant: string;

    @Column('varchar', {
        nullable: true,
        length: 50,
        name: 'to_Plant'
    })
    toPlant: string;



    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at',
        type: 'datetime'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;


}